"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationIDCardRequest = void 0;
var VerificationIDCardRequest = /** @class */ (function () {
    function VerificationIDCardRequest() {
    }
    return VerificationIDCardRequest;
}());
exports.VerificationIDCardRequest = VerificationIDCardRequest;
;
//# sourceMappingURL=verificationIDCard.request.js.map